import { Injectable, signal } from '@angular/core';

/**
 * Root-provided channel for the global header search term.
 *
 * WHY a store instead of a query param or sessionStorage: the header (app shell)
 * and the results page (`/searchBar`) are separate components, so the term needs a
 * shared channel. This project does NOT pass state through the URL — a `?q=` query
 * param is explicitly disallowed — nor through sessionStorage (see CLAUDE.md state
 * rules). A root-provided signal is the idiomatic channel: the header writes it and
 * navigates; the results page reads it reactively (so re-searching while already on
 * `/searchBar`, which doesn't re-create the component, still re-fires the fetch).
 *
 * Trade-off (accepted): the term is in-memory, so a hard refresh of `/searchBar`
 * starts empty — the same behaviour router nav-state would give, and correct for a
 * search results page (the user simply searches again).
 */
@Injectable({ providedIn: 'root' })
export class SearchBarStore {
  /** Current search term. Empty means "no active search" (grids stay cleared). */
  private readonly _term = signal('');

  /** Read-only view the results page consumes. */
  readonly term = this._term.asReadonly();

  /** Sets the active search term (called by the header on submit). */
  setTerm(term: string): void {
    this._term.set(term);
  }
}
